export enum MetadataMode {
    Git,
    Live,
    Configure // To be configured
}
